import React from 'react';
import { useQuery } from 'react-query';
import api from '../config/api';
import { queryKeys, staleTimes } from '../config/queryKeys';

/** Timesheet delivery-project picker. Loads active projects from GET /projects. */
export function ProjectSelector({ value, onChange, disabled = false, id, allowEmpty = true }) {
  const projects = useQuery(
    queryKeys.erpProjects,
    () => api.get('/projects', { params: { status: 'active' } }).then((r) => r.data),
    { staleTime: staleTimes.reference }
  );
  const rows = Array.isArray(projects.data) ? projects.data : [];
  return (
    <select
      id={id}
      value={value ?? ''}
      onChange={(event) => onChange?.(event.target.value)}
      disabled={disabled || projects.isLoading}
    >
      {allowEmpty && <option value="">— No project —</option>}
      {rows.map((project) => (
        <option key={project.id} value={project.id}>
          {project.code ? `${project.code} · ` : ''}{project.name}
        </option>
      ))}
    </select>
  );
}
